import { Model } from 'core/models';
export class EnumList extends Model {
  public id?: number;
  public code?: string;
  public name?: string;
}
